<template>
  <div>
    <div class="d-flex align-center">
      <h2>{{ $t('systemSetting.title') }}</h2>
      <v-spacer />
      <v-btn
        @click="getSystem"
        :loading="loading"
        color="primary"
        variant="outlined"
      >
        <v-icon start>mdi-sync</v-icon>
        {{ $t('systemSetting.refresh') }}
      </v-btn>
    </div>

    <div class="mt-6" v-if="systemResponse">
      <v-card variant="outlined">
        <v-card-title>CCS HOME</v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center">
              <v-col :cols="views.titleCols">
                <h4>{{ $t('systemSetting.parentChatPermission') }}</h4>
              </v-col>
              <v-col :cols="views.textCols">
                <v-switch
                  v-model="systemResponse.chat.isEnabled"
                  :disabled="loading"
                  color="primary"
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </div>

    <!-- button -->
    <div class="mt-4">
      <v-row align="center" justify="center">
        <v-col cols="4">
          <v-btn
            @click="updateSystem"
            :disabled="loading"
            color="primary"
            variant="flat"
            block
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { NurserySystemSettingsResponse } from "chaild-api/lib";
import LocalDataService from "@/service/LocalDataService";
import ApiSystemSetting from "@/api/ApiSystemSetting";

export default defineComponent({
  name: "SystemSetting",

  async mounted() {
    await this.getSystem();
  },

  data() {
    return {
      loading: false,
      systemResponse: null as null | NurserySystemSettingsResponse,
      views: {
        titleCols: 4,
        textCols: 8,
      },
    };
  },

  methods: {
    async getSystem() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiSystemSetting.getSetting({
          nurseryId,
        }).catch(() => (this.loading = false));
        if (response) {
          this.systemResponse = response;
        }
      }
      this.loading = false;
    },
    async updateSystem() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId && this.systemResponse) {
        const response = await ApiSystemSetting.updateSetting({
          nurseryId,
          ...this.systemResponse,
        }).catch(() => (this.loading = false));
        if (response) {
          alert(this.$t('systemSetting.updated'));
          this.getSystem();
        }
      }
      this.loading = false;
    },
  },
});
</script>
